import { render, staticRenderFns } from "./reservation-notes.vue?vue&type=template&id=de0ed41e&scoped=true&lang=pug"
import script from "./reservation-notes.vue?vue&type=script&lang=js"
export * from "./reservation-notes.vue?vue&type=script&lang=js"
import style0 from "./reservation-notes.vue?vue&type=style&index=0&id=de0ed41e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de0ed41e",
  null
  
)

export default component.exports